module.exports = __webpack_public_path__ + "static/media/american-samoa.044bba47.svg";